document.addEventListener('DOMContentLoaded', () => {
  if (window.lucide) window.lucide.createIcons();

  const loader = document.getElementById('game-loader');
  const pixelBar = document.getElementById('pixel-bar');
  const pixelPercent = document.getElementById('pixel-percentage');
  const header = document.getElementById('main-header');
  const productForm = document.querySelector('[data-product-form]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartBackdrop = document.querySelector('[data-cart-close].cart-drawer-backdrop');
  const cartItems = document.querySelector('[data-cart-items]');
  const cartFooter = document.querySelector('[data-cart-footer]');
  const cartSubtotal = document.querySelector('[data-cart-subtotal]');
  const cartCountElements = document.querySelectorAll('[data-cart-count]');

  const routesRoot = window.Shopify?.routes?.root || '/';

  function formatMoney(cents, currency = 'CAD') {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency
    }).format((cents || 0) / 100);
  }

  function showLoader(next) {
    if (!loader || !pixelBar || !pixelPercent) {
      next();
      return;
    }

    loader.classList.remove('hidden');
    pixelBar.style.width = '0%';
    pixelPercent.textContent = '0%';
    let progress = 0;

    const interval = setInterval(() => {
      progress += Math.random() * 25;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
        next();
        setTimeout(() => loader.classList.add('hidden'), 250);
      }
      pixelBar.style.width = `${progress}%`;
      pixelPercent.textContent = `${Math.floor(progress)}%`;
    }, 80);
  }

  function navigateToView(targetViewId, skipAnimation = false) {
    const target = document.getElementById(`view-${targetViewId}`);
    if (!target) return;

    const switchView = () => {
      document.querySelectorAll('.view').forEach(v => v.classList.remove('active'));
      target.classList.add('active');

      if (header) {
        if (targetViewId === 'landing') header.classList.add('header--hidden');
        else header.classList.remove('header--hidden');
      }
    };

    if (skipAnimation) switchView();
    else showLoader(switchView);
  }

  document.querySelectorAll('.nav-link').forEach(link => {
    link.addEventListener('click', event => {
      const target = link.getAttribute('data-target');
      if (!target) return;
      event.preventDefault();
      navigateToView(target);
    });
  });

  if (document.getElementById('view-landing')) {
    navigateToView('landing', true);
  }

  function getVariantOptions() {
    const select = document.querySelector('[data-variant-select]');
    if (!select) return [];
    return Array.from(select.options).map(option => ({
      id: option.value,
      available: option.dataset.available === 'true',
      price: option.dataset.price,
      options: JSON.parse(option.dataset.options || '[]')
    }));
  }

  function updateSelectedVariant() {
    const select = document.querySelector('[data-variant-select]');
    if (!select) return;

    const selectedByPosition = [];
    document.querySelectorAll('.size-btn.active').forEach(button => {
      selectedByPosition[Number(button.dataset.optionPosition) - 1] = button.dataset.optionValue;
    });

    const matchingVariant = getVariantOptions().find(variant => {
      return variant.options.every((value, index) => value === selectedByPosition[index]);
    });

    if (!matchingVariant) return;

    select.value = matchingVariant.id;

    const priceEl = document.querySelector('[data-product-price]');
    if (priceEl) priceEl.textContent = matchingVariant.price;

    const addButton = document.querySelector('[data-add-to-cart]');
    const addText = document.querySelector('[data-add-to-cart-text]');
    if (addButton && addText) {
      addButton.disabled = !matchingVariant.available;
      addText.textContent = matchingVariant.available ? 'Add to Cart' : 'Sold Out';
    }
  }

  document.querySelectorAll('.size-btn').forEach(button => {
    button.addEventListener('click', () => {
      const position = button.dataset.optionPosition;
      document.querySelectorAll(`.size-btn[data-option-position="${position}"]`).forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');
      updateSelectedVariant();
    });
  });

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartBackdrop) cartBackdrop.hidden = false;
    refreshCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartBackdrop) cartBackdrop.hidden = true;
  }

  document.querySelectorAll('[data-cart-open]').forEach(btn => btn.addEventListener('click', openCart));
  document.querySelectorAll('[data-cart-close]').forEach(btn => btn.addEventListener('click', closeCart));

  async function refreshCart() {
    const response = await fetch(`${routesRoot}cart.js`);
    const cart = await response.json();
    renderCart(cart);
  }

  function renderCart(cart) {
    cartCountElements.forEach(el => {
      el.textContent = cart.item_count;
      el.style.transform = 'scale(1.35)';
      setTimeout(() => el.style.transform = 'scale(1)', 180);
    });

    if (!cartItems || !cartFooter || !cartSubtotal) return;

    if (!cart.items.length) {
      cartItems.innerHTML = '<p class="empty-cart">Your cart is currently empty.</p>';
      cartFooter.hidden = true;
      return;
    }

    cartItems.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <div class="cart-item-info">
          <h4>${item.product_title}</h4>
          ${item.variant_title ? `<p>${item.variant_title}</p>` : ''}
          <p>Qty: ${item.quantity}</p>
          <button type="button" class="remove-cart-item" data-remove-line="${item.key}">Remove</button>
        </div>
        <div class="cart-item-price">${formatMoney(item.final_line_price, cart.currency)}</div>
      </div>
    `).join('');

    cartSubtotal.textContent = formatMoney(cart.total_price, cart.currency);
    cartFooter.hidden = false;

    cartItems.querySelectorAll('[data-remove-line]').forEach(button => {
      button.addEventListener('click', async () => {
        await fetch(`${routesRoot}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: button.dataset.removeLine, quantity: 0 })
        });
        refreshCart();
      });
    });
  }

  if (productForm) {
    productForm.addEventListener('submit', async event => {
      event.preventDefault();

      const addButton = productForm.querySelector('[data-add-to-cart]');
      const addText = productForm.querySelector('[data-add-to-cart-text]');
      const originalText = addText?.textContent || 'Add to Cart';
      const formData = new FormData(productForm);

      try {
        if (addButton) addButton.disabled = true;
        if (addText) addText.textContent = 'Adding...';

        const response = await fetch(`${routesRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'Could not add item to cart.');
        }

        if (addText) addText.textContent = 'Added';
        await refreshCart();
        openCart();
      } catch (error) {
        alert(error.message);
        if (addText) addText.textContent = originalText;
      } finally {
        setTimeout(() => {
          if (addButton) addButton.disabled = false;
          if (addText) addText.textContent = originalText;
        }, 900);
      }
    });
  }

  const buyNowButton = document.querySelector('[data-buy-now]');
  if (buyNowButton && productForm) {
    buyNowButton.addEventListener('click', async () => {
      const formData = new FormData(productForm);
      buyNowButton.disabled = true;
      buyNowButton.textContent = 'Opening checkout...';

      try {
        const response = await fetch(`${routesRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'Could not add item to cart.');
        }
        window.location.href = '/checkout';
      } catch (error) {
        alert(error.message);
        buyNowButton.disabled = false;
        buyNowButton.textContent = 'Buy now';
      }
    });
  }

  const productVisuals = document.querySelectorAll('.hover-swap, .catalog-image-wrapper');
  productVisuals.forEach(wrapper => {
    wrapper.addEventListener('mousemove', event => {
      const rect = wrapper.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const rotateX = ((y - rect.height / 2) / (rect.height / 2)) * -15;
      const rotateY = ((x - rect.width / 2) / (rect.width / 2)) * 15;
      wrapper.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-20px) scale3d(1.02, 1.02, 1.02)`;
    });

    wrapper.addEventListener('mouseleave', () => {
      wrapper.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) translateY(0) scale3d(1, 1, 1)';
    });
  });

  refreshCart().catch(() => {});
});
